import Layout from "components/layout";
import FinancialTranslation from "components/reusableComponents/financialTranslation/FinancialTranslation";
import SEO from "components/seo";
import React from "react";

function Index() {
  const title = "Financial Translation Services | Tomedes";
  const description =
    "Tomedes follows best practices in providing financial translation services to its worldwide clients, including accountancy, banking and insurance firms";
  const keywords =
    "financial translation, professional financial translation, financial translation quote";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/financial-translation.php"
      />
      <FinancialTranslation />
    </Layout>
  );
}

export default Index;
